import { Spin, Checkbox } from 'antd';
import { AppModal } from '@components/form/Modal';
import ContactItemCard from './contact-item-card';
import { LoadMoreSkeleton } from '@modules/settings/workspace/utils/load-more-skeleton';
import { ContactSelectListProps } from './bulk-messaging.types';

export const ContactSelectList = (props: ContactSelectListProps) => {
  const {
    title,
    contacts,
    selectedContactIds,
    onToggle,
    onSelectAll,
    showCheckbox,
    hasNextPage,
    loadMoreRef,
    isSearching,
  } = props;
  if (contacts.length === 0 && !isSearching) return null;

  const allSelected = contacts.length > 0 && contacts.every((c) => selectedContactIds?.includes(c.id ?? '') ?? false);
  const someSelected = contacts.length > 0 && contacts.some((c) => selectedContactIds?.includes(c.id ?? '') ?? false);

  const content = (
    <div className="space-y-1">
      {contacts.map((contact) => (
        <ContactItemCard
          key={contact.id}
          contact={contact}
          showCheckbox={showCheckbox}
          {...(selectedContactIds && contact.id ? { checked: selectedContactIds.includes(contact.id) } : {})}
          {...(onToggle && {
            onToggle: () => onToggle(contact),
          })}
        />
      ))}
    </div>
  );

  return (
    <>
      {title && (
        <div className="flex items-center justify-between">
          <AppModal.SubTitle className="mt-3 mb-2!">{title}</AppModal.SubTitle>
          {showCheckbox && onSelectAll && (
            <Checkbox
              indeterminate={someSelected && !allSelected}
              checked={allSelected}
              onClick={() => onSelectAll(contacts)}
              className="mr-2!"
            />
          )}
        </div>
      )}
      {isSearching ? (
        <div className="h-20 flex items-center justify-center">
          <Spin></Spin>{' '}
        </div>
      ) : (
        content
      )}
      {!isSearching && hasNextPage && loadMoreRef && (
        <LoadMoreSkeleton initialLoading={false} hasNextPage={hasNextPage} loadNextRef={loadMoreRef} />
      )}
    </>
  );
};
